import React, { useState } from 'react';

export const UserLoginContext = React.createContext();

export const UserLogin = ({ children }) => {
  const [isLoggedin, setLoggedIn] = useState(false);
  const [userData, setUserData] = useState({});
  const [latestOrder, setLatestOrder] = useState({});
  const [multiArray, setMultiArray] = useState([]);
  const [count, setCount] = useState({});
  const [referral, setReferral] = useState({});
  const [summary, setSummary] = useState({});

  return (
    <UserLoginContext.Provider
        value={{
          isLoggedin,
          userData,
          latestOrder,
          multiArray,
          count,
          referral,
          summary,
          setUserData: (val) => setUserData(val),
          setLoggedIn: (val) => setLoggedIn(val),
          setLatestOrder: (val) => setLatestOrder(val),
          setMultiArray: (val) => setMultiArray(val),
          setCount: (val) => setCount(val),
          setReferral: (val) => setReferral(val),
          setSummary: (val) => setSummary(val),
        }}>
      {children}
    </UserLoginContext.Provider>
  );
};
